(() => {
  if (window.ssCollectionGroups) {
    window.ssCollectionGroups.refresh();
    return;
  }
  const states = new WeakMap();
  let timer;
  let observer;
  const container = () => document.querySelector('main') || document.body;
  const observe = () => observer.observe(container(), { childList: true, subtree: true });
  function refresh() {
    observer.disconnect();
    try {
      document.querySelectorAll('[data-ss-collection-config]').forEach(node => {
        let config;
        try { config = JSON.parse(node.textContent); } catch { return; }
        const root = Array.from(document.querySelectorAll('[data-ss-collection-id]')).find(el => el.dataset.ssCollectionId === String(config.collectionId));
        const section = root?.closest('.shopify-section--main-collection');
        const list = root?.querySelector('product-list.product-list');
        if (!section || !list) return;
        const cards = Array.from(list.querySelectorAll('product-card[data-ss-product-id]')).filter(card => card.closest('product-list') === list);
        if (!cards.length) return;
        if (config.mode === 'trial') {
          cards.forEach(card => {
            const matches = card.dataset.ssProductId === String(config.productId);
            card.classList.toggle('ss-probeset-card', matches);
            if (matches) card.querySelector('.product-card__info')?.setAttribute('data-ss-trial-label', config.label);
          });
          section.classList.toggle('ss-probeset-grid-section', cards.some(card => card.dataset.ssProductId === String(config.productId)));
          return;
        }
        const params = new URLSearchParams(location.search);
        const useNative = params.has('sort_by') || (config.mode === 'headings' && Array.from(params.keys()).some(key => key.startsWith('filter.')));
        const signature = node.textContent + '\n' + location.search;
        let state = states.get(list);
        if (state?.signature === signature && state.cards.length === cards.length && cards.every(card => state.cards.includes(card))) return;
        if (state) {
          state.original.forEach(child => list.append(child));
          list.querySelectorAll(':scope > [data-ss-generated-group]').forEach(child => child.remove());
          list.classList.remove(`ss-${state.prefix}-grouped-list`);
          delete section.dataset.ssGroupStyle;
        }
        const original = Array.from(list.children);
        const originalCards = original.filter(child => child.matches('product-card[data-ss-product-id]'));
        state = { original, cards: originalCards, signature, prefix: config.prefix };
        states.set(list, state);
        if (useNative || originalCards.length !== cards.length) return;
        const idMap = new Map(originalCards.map(card => [card.dataset.ssProductId, card]));
        if (idMap.size !== originalCards.length) return;
        const used = new Set();
        const batches = config.groups.map(group => ({ ...group, cards: group.ids.map(String).filter(id => idMap.has(id) && !used.has(id) && used.add(id)).map(id => idMap.get(id)) })).filter(group => group.cards.length);
        if (!batches.length) return;
        const remaining = originalCards.filter(card => !used.has(card.dataset.ssProductId));
        if (remaining.length) batches.push({ key: 'weitere', anchor: `ss-${config.prefix}-weitere`, title: config.fallbackTitle, description: config.fallbackDescription, cards: remaining });
        try {
          const fragment = document.createDocumentFragment();
          batches.forEach(group => {
            if (config.mode === 'headings') {
              const heading = document.createElement('div');
              heading.dataset.ssGeneratedGroup = '';
              heading.id = group.anchor;
              heading.className = `ss-pad-grid-heading ss-pad-grid-heading--${group.key}`;
              const title = document.createElement('span');
              title.className = 'ss-pad-grid-heading__title';
              title.textContent = group.title;
              const description = document.createElement('span');
              description.className = 'ss-pad-grid-heading__text';
              description.textContent = group.description;
              heading.append(title, description);
              fragment.append(heading, ...group.cards);
              return;
            }
            const wrapper = document.createElement('section');
            wrapper.dataset.ssGeneratedGroup = '';
            wrapper.id = group.anchor;
            wrapper.className = `ss-${config.prefix}-grid-group ss-${config.prefix}-grid-group--${group.key}`;
            const heading = document.createElement('div');
            heading.className = `ss-${config.prefix}-grid-heading`;
            const title = document.createElement('h2');
            title.className = `ss-${config.prefix}-grid-title`;
            title.id = `${group.anchor}-title`;
            title.textContent = group.title;
            wrapper.setAttribute('aria-labelledby', title.id);
            const description = document.createElement('p');
            description.className = `ss-${config.prefix}-grid-description`;
            description.textContent = group.description;
            const grid = document.createElement('div');
            grid.className = `ss-${config.prefix}-group-grid`;
            grid.dataset.count = String(group.cards.length);
            grid.append(...group.cards);
            heading.append(title, description);
            wrapper.append(heading, grid);
            fragment.append(wrapper);
          });
          if (config.mode !== 'headings') list.classList.add(`ss-${config.prefix}-grouped-list`);
          section.dataset.ssGroupStyle = config.prefix;
          list.append(fragment);
          (config.badges || []).forEach(badge => {
            const card = idMap.get(String(badge.id));
            if (!card || !badge.label) return;
            let chip = card.querySelector('[data-ss-group-badge]');
            if (!chip) {
              chip = document.createElement('span');
              chip.dataset.ssGroupBadge = '';
              chip.className = config.prefix === 'master' ? 'ss-master-special-badge' : `ss-${config.prefix}-product-chip`;
              const target = config.prefix === 'master' ? card : card.querySelector('.product-card__info .v-stack');
              if (!target) return;
              target.prepend(chip);
            }
            chip.textContent = badge.label;
          });
        } catch {
          original.forEach(child => list.append(child));
          list.querySelectorAll(':scope > [data-ss-generated-group]').forEach(child => child.remove());
          list.classList.remove(`ss-${config.prefix}-grouped-list`);
          delete section.dataset.ssGroupStyle;
        }
      });
      document.dispatchEvent(new CustomEvent('ss:collection:updated'));
    } finally { observe(); }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 60); }
  observer = new MutationObserver(schedule);
  window.ssCollectionGroups = { refresh: schedule };
  window.addEventListener('popstate', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
